<template>
  <div>
    <v-row class="mb-2 fill-height">
      <v-col cols="12">
        <v-card>
          <v-card-title primary-title>
            Leads Call Center ( {{ query.status }} )
            <v-spacer></v-spacer>
            <v-btn
              @click="$router.go(-1)"
              style="background-color: #ff0042; color: white"
            >
              FINALIZAR
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-card
        dense
        v-for="(producto, i) in productos"
        :key="i"
        :color="query.producto == producto.name ? 'primary' : ''"
        :dark="query.producto == producto.name"
        tile
        @click="addQueryBuilder('producto', producto.name)"
      >
        <v-card-text class="text-subtitle-2 text-center">
          <span>{{ producto.name }} ({{ producto.total }})</span>
        </v-card-text>
      </v-card>
    </v-row>

    <v-expand-transition>
      <v-row
        v-if="query.producto != null"
        dense
        class="d-flex justify-space-around mt-4"
      >
        <v-col cols="12">
          <v-card dense>
            <v-card-text>
              <v-form ref="filters">
                <v-row>
                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Producto aseguradora"
                      v-model="query.aseguradora"
                      :items="IdBradescard"
                      hide-details
                      outlined
                      dense
                      :rules="[$rules.required]"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Etiqueta"
                      :items="etiquetas"
                      v-model="query.etiqueta"
                      hide-details
                      outlined
                      dense
                      :rules="[$rules.required]"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Corte"
                      :items="cortes"
                      v-model="query.corte"
                      hide-details
                      multiple
                      outlined
                      dense
                      :rules="[$rules.required]"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Base mes"
                      :items="base_mes_disponibles"
                      v-model="query.base_mes"
                      item-value="value"
                      item-text="name"
                      hide-details
                      multiple
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Intentos"
                      :items="intentos"
                      v-model="query.intentos"
                      hide-details
                      multiple
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Última disposición"
                      :items="ultimasDisposiciones"
                      v-model="query.ultima_disposicion"
                      hide-details
                      item-text="disposicion"
                      outlined
                      dense
                      multiple
                    ></v-autocomplete>
                  </v-col>

                  <v-col v-if="mostrarFiltroFechaUltimaLlamada" cols="6" md="3">
                    <v-menu
                      v-model="menuFechaUltimaLlamada"
                      :close-on-content-click="false"
                      max-width="300"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="fechaUltimaLlamadaTexto"
                          label="Fecha última llamada"
                          prepend-inner-icon="mdi-calendar"
                          :rules="[
                            () =>
                              query.fecha_ultima_llamada.length === 0 ||
                              query.fecha_ultima_llamada.length === 2 ||
                              'Seleccione un rango completo',
                          ]"
                          hide-details="auto"
                          outlined
                          dense
                          readonly
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="query.fecha_ultima_llamada = []"
                        ></v-text-field>
                      </template>

                      <v-card width="300">
                        <v-date-picker
                          v-model="query.fecha_ultima_llamada"
                          range
                          locale="es"
                          width="300"
                        ></v-date-picker>
                        <v-card-actions>
                          <v-btn
                            small
                            text
                            @click="query.fecha_ultima_llamada = []"
                          >
                            Limpiar
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            small
                            text
                            :disabled="query.fecha_ultima_llamada.length === 1"
                            @click="menuFechaUltimaLlamada = false"
                          >
                            Listo
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-autocomplete
                      label="Operador"
                      v-model="query.operador_id"
                      :items="agentesActivos"
                      item-value="id"
                      :item-text="nombreCompletoAgente"
                      :filter="filtrarAgente"
                      hide-details
                      outlined
                      dense
                      clearable
                    >
                      <template v-slot:item="{ item }">
                        {{ nombreCompletoAgente(item) }}
                      </template>
                      <template v-slot:selection="{ item }">
                        {{ nombreCompletoAgente(item) }}
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="6" md="3">
                    <v-select
                      label="Score Leads"
                      v-model="query.score"
                      :items="scoreLeads"
                      item-text="text"
                      item-value="value"
                      hide-details
                      outlined
                      dense
                      clearable
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="clearFilters" small>
                <v-icon>mdi-trash</v-icon>Limpiar filtros
              </v-btn>
              <v-btn color="primary" @click="buscarLeads" small>
                <v-icon>mdi-magnify</v-icon>Buscar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-expand-transition>

    <v-row v-if="query.producto == null" class="mt-2">
      <v-col cols="12">
        <v-alert dense text type="info"> Debe seleccionar un producto </v-alert>
      </v-col>
    </v-row>

    <v-row dense class="mt-3 mb-12" v-if="leads != null">
      <v-col cols="12">
        <v-card flat>
          <v-data-table
            :headers="columns"
            :items="leads"
            item-key="uuid"
            class="elevation-1"
            :search="search"
            :loading="loading"
            :options.sync="opcionesTabla"
            :server-items-length="totalRegistros"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
              'items-per-page-text': 'Registros por página',
            }"
            loading-text="Cargando..."
          >
            <template v-slot:top>
              <v-toolbar dense flat>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      plain
                      :disabled="leads.length <= 0"
                    >
                      <v-icon>mdi-clipboard-text</v-icon>Asignación leads
                    </v-btn>
                  </template>

                  <v-card class="asignacion-card" dense v-if="leads.length > 0">
                    <v-card-text>
                      <v-form ref="asignacion">
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              label="Leads por operador"
                              dense
                              v-model.number="form.registros"
                              :hint="
                                totalSolicitadoAsignacion > 0
                                  ? `Hasta ${totalSolicitadoAsignacion} leads en total; se asignarán los disponibles.`
                                  : 'Cantidad que recibirá cada operador seleccionado.'
                              "
                              persistent-hint
                              :rules="[
                                $rules.required,
                                $rules.numeric,
                                $rules.mayorIgual(1),
                              ]"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete
                              class="operadores-select"
                              label="Asignar a"
                              v-model="form.operadoresIds"
                              :items="agentesActivos"
                              item-value="id"
                              item-text="nombre"
                              :rules="[
                                (operadores) =>
                                  operadores.length > 0 ||
                                  'Seleccione al menos un operador',
                              ]"
                              multiple
                              clearable
                              dense
                            >
                              <template v-slot:item="{ item, attrs, on }">
                                <v-list-item-action>
                                  <v-simple-checkbox
                                    :value="attrs.inputValue"
                                    color="primary"
                                    @input="on.click"
                                  ></v-simple-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ item.nombre }}
                                    {{ item.apellidoPaterno }}
                                    {{ item.apellidoMaterno }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>
                              <template v-slot:selection="{ item, index }">
                                <span class="operador-seleccion">
                                  {{ item.nombre }} {{ item.apellidoPaterno }}
                                  {{ item.apellidoMaterno
                                  }}<span
                                    v-if="index < form.operadoresIds.length - 1"
                                    >, &nbsp;</span
                                  >
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        small
                        :loading="asignando"
                        :disabled="asignando"
                        @click="asignacion"
                      >
                        Asignar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>

                <v-spacer></v-spacer>

                <v-text-field
                  class="mt-4"
                  v-model="search"
                  append-icon="mdi-magnify"
                  dense
                ></v-text-field>
              </v-toolbar>
            </template>

            <template #[`item.mail`]="{ item }">
              <span v-email="item.correo"></span>
            </template>

            <template #[`item.fecha_ultima_llamada`]="{ item }">
              {{ formatearFechaUltimaLlamada(item.fecha_ultima_llamada) }}
            </template>

            <template #[`item.score`]="{ item }">
              {{
                item.score !== null && item.score !== undefined
                  ? item.score
                  : "-"
              }}
            </template>

            <template #[`item.actions`]="{ item }">
              <v-btn
                icon
                :to="{
                  name: 'DetalleLeadBradescard',
                  params: { uuid: item.uuid },
                }"
              >
                <v-icon small class="mr-2">mdi-eye</v-icon>
              </v-btn>
            </template>

            <template #no-data>
              Se tiene que seleccionar todos los filtros
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar :value="asignando" :timeout="-1" color="primary" top>
      <v-progress-circular
        class="mr-3"
        indeterminate
        size="20"
        width="2"
      ></v-progress-circular>
      Asignando leads y actualizando los datos...
    </v-snackbar>

    <v-snackbar
      v-model="notificacion.visible"
      :color="notificacion.color"
      :timeout="4000"
      top
    >
      {{ notificacion.mensaje }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="notificacion.visible = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { ListExpanded } from "./../../../../../plugins/mixins";
export default {
  name: "Bradescard.ListaLeads",
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  mixins: [ListExpanded],
  data: function () {
    return {
      asignando: false,
      notificacion: {
        visible: false,
        color: "success",
        mensaje: "",
      },
      cortes: [],
      menu: false,
      menuFechaUltimaLlamada: false,
      loading: false,
      search: "",
      leads: [],
      totalRegistros: 0,
      consultaRealizada: false,
      recargaPaginacionPendiente: false,
      opcionesTabla: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      agentesActivos: [],
      columns: [
        { text: "Estatus Lead", value: "status", sortable: false },
        {
          text: "Ultima disposición",
          value: "ultimaDisposicion",
          sortable: false,
        },
        {
          text: "Número de llamadas Realizadas",
          value: "numLlamadas",
          sortable: false,
        },
        // { text: '4UD', value: 'fourUD' },
        { text: "Nombre", value: "nombre", sortable: false },
        { text: "Ciudad", value: "ciudad", sortable: false },
        { text: "Estado", value: "estado", sortable: false },
        { text: "Corte", value: "corte", sortable: false },
        { text: "Edad", value: "edad", sortable: false },
        { text: "Correo electronico", value: "mail", sortable: false },
        { text: "Fecha última llamada", value: "fecha_ultima_llamada" },
        { text: "Score", value: "score" },
        { text: "Ver", value: "actions", sortable: false },
      ],
      query: {
        status: null,
        producto: null,
        aseguradora: null,
        etiqueta: null,
        corte: null,
        ultima_disposicion: null,
        operador_id: null,
        intentos: null,
        base_mes: null,
        score: null,
        fecha_ultima_llamada: [],
      },

      form: {
        operadoresIds: [],
        registros: null,
      },
      base_mes_disponibles: [],
      intentos: [],
      scoreLeads: [
        { text: "P6", value: "P6" },
        { text: "P5", value: "P5" },
        { text: "P4", value: "P4" },
        { text: "P3", value: "P3" },
        { text: "P2", value: "P2" },

        { text: "P1", value: "P1" },
      ],
    };
  },
  computed: {
    totalSolicitadoAsignacion() {
      const registros = Number(this.form.registros);
      const operadores = this.form.operadoresIds.length;

      return registros > 0 && operadores > 0 ? registros * operadores : 0;
    },
    mostrarFiltroFechaUltimaLlamada() {
      const estatusPermitidos = [
        "No Efectivo Seguimiento",
        "No Efectivo Finalizado",
        "Efectivo Seguimiento",
        "Efectivo Venta",
        "Efectivo No Venta",
      ];

      return estatusPermitidos.includes(this.query.status);
    },
    fechaUltimaLlamadaTexto() {
      return (this.query.fecha_ultima_llamada || [])
        .map((fecha) => moment(fecha).format("DD/MM/YYYY"))
        .join(" a ");
    },
  },
  watch: {
    mostrarFiltroFechaUltimaLlamada(mostrar) {
      if (!mostrar) {
        this.query.fecha_ultima_llamada = [];
        this.menuFechaUltimaLlamada = false;
      }
    },
    "opcionesTabla.page": "programarRecargaPaginacion",
    "opcionesTabla.itemsPerPage": "programarRecargaPaginacion",
    "opcionesTabla.sortBy": {
      handler: "actualizarOrdenTabla",
      deep: true,
    },
    "opcionesTabla.sortDesc": {
      handler: "actualizarOrdenTabla",
      deep: true,
    },
  },
  async mounted() {
    if (this.status != "") {
      // verifico que no se haya un status
      if (localStorage.getItem("status")) {
        // verifico que exista el status en localstore
        if (this.status == localStorage.getItem("status")) {
          // verifico si el valor que esta en localstorage, le asigno al query
          this.query.status = localStorage.getItem("status");
        } else {
          // en caso de que sea diferente, agrego el nuevo dato
          localStorage.setItem("status", this.status);
          this.query.status = this.status;
        }
      } else {
        // en caso de que no exista, agrego el status
        localStorage.setItem("status", this.status);
        this.query.status = this.status;
      }
    } else {
      // en caso de que no se haya enviado un status, tomo el localstore
      this.query.status = localStorage.getItem("status");
    }
    this.getProductos();
    this.getAgentes(0);
    this.getAgentes(1);
    this.getProductosAseguradora();
    this.getDisposiciones();
  },
  methods: {
    nombreCompletoAgente(agente) {
      return [agente.nombre, agente.apellidoPaterno, agente.apellidoMaterno]
        .filter(Boolean)
        .join(" ");
    },
    normalizarBusqueda(texto) {
      return String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    filtrarAgente(item, busqueda) {
      const nombre = this.normalizarBusqueda(this.nombreCompletoAgente(item));
      const terminos = this.normalizarBusqueda(busqueda)
        .split(/\s+/)
        .filter(Boolean);

      return terminos.every((termino) => nombre.includes(termino));
    },
    formatearFechaUltimaLlamada(fecha) {
      if (!fecha) {
        return "-";
      }

      const fechaFormateada = moment(fecha).format("DD/MM/YYYY HH:mm");
      return fechaFormateada === "Invalid date" ? fecha : fechaFormateada;
    },
    programarRecargaPaginacion() {
      if (!this.consultaRealizada || this.recargaPaginacionPendiente) {
        return;
      }

      this.recargaPaginacionPendiente = true;
      this.$nextTick(() => {
        this.recargaPaginacionPendiente = false;
        this.LoadLeads();
      });
    },
    actualizarOrdenTabla() {
      this.opcionesTabla.page = 1;
      this.programarRecargaPaginacion();
    },
    async getProductosAseguradora() {
      let { data } = await this.$axios.get("v1/bradescard/aseguradoras", {
        params: {
          status: this.query.status,
        },
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      });
      this.IdBradescard = [];
      this.cortes = [];
      this.base_mes_disponibles = [];
      this.intentos = [];
      for (let i in data.aseguradoras) {
        this.IdBradescard.push(i);
      }
      for (let i in data.cortes) {
        this.cortes.push(i);
      }
      for (let i in data.base_mes) {
        let fecha = moment(i).format("DD/MM/YYYY");
        if (fecha != "Invalid date")
          this.base_mes_disponibles.push({ value: i, name: fecha });
      }
      for (let i in data.intentos) {
        this.intentos.push(i);
      }
    },
    async getDisposiciones() {
      let { data } = await this.$axios.get(`v1/bradescard/disposicion/list `, {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      });
      this.ultimasDisposiciones = data;
    },
    addQueryBuilder(type, value) {
      if (this.query.producto != value) {
        this.leads = [];
      }
      this.query.producto = value;
    },
    async clearFilters() {
      const statusActual = this.query.status;
      this.consultaRealizada = false;
      this.totalRegistros = 0;
      this.leads = [];
      this.opcionesTabla.page = 1;
      this.query = {};
      Object.assign(this.query, {
        status: statusActual,
        producto: null,
        aseguradora: null,
        etiqueta: null,
        corte: null,
        ultima_disposicion: null,
        operador_id: null,
        intentos: null,
        base_mes: null,
        score: null,
        fecha_ultima_llamada: [],
      });
      if (this.loadFilters) {
        this.filterLeads();
      }
      this.loadFilters = !this.loadFilters;
    },
    async getAgentes(status) {
      try {
        this.agentes = [];
        this.agentesActivos = [];

        let { data } = await this.$axios.get(`v1/agente/operadores/${status}`, {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        });
        if (status == 0) {
          this.agentes = [...data];
        } else if (status == 1) {
          this.agentesActivos = [...data];
        }
      } catch (exception) {
        console.error(exception);
      }
    },
    async getProductos() {
      try {
        // HERe
        let { data } = await this.$axios.get("v1/bradescard/productos", {
          params: {
            status: this.query.status,
          },
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        });
        this.productos = [];
        for (let key in data.status) {
          this.productos.push({
            name: key,
            total: data.status[key],
          });
        }
      } catch (exception) {
        console.error(exception);
      }
    },
    buscarLeads() {
      return this.LoadLeads(true);
    },
    crearFiltrosLeads(incluirPaginacion = false) {
      const filtros = { ...this.query };

      if (
        Array.isArray(filtros.ultima_disposicion) &&
        filtros.ultima_disposicion.length === 0
      ) {
        filtros.ultima_disposicion = null;
      }

      if (
        this.mostrarFiltroFechaUltimaLlamada &&
        Array.isArray(filtros.fecha_ultima_llamada) &&
        filtros.fecha_ultima_llamada.length === 2
      ) {
        filtros.fecha_ultima_llamada = [...filtros.fecha_ultima_llamada].sort();
      } else {
        delete filtros.fecha_ultima_llamada;
      }

      if (!incluirPaginacion) {
        return filtros;
      }

      filtros.pagina = this.opcionesTabla.page;
      filtros.registrosPagina = this.opcionesTabla.itemsPerPage;

      const campoOrden = this.opcionesTabla.sortBy[0];
      const camposOrdenables = ["score", "fecha_ultima_llamada"];
      if (camposOrdenables.includes(campoOrden)) {
        filtros.ordenCampo = campoOrden;
        filtros.ordenDireccion = this.opcionesTabla.sortDesc[0]
          ? "desc"
          : "asc";
      }

      return filtros;
    },
    crearMensajeAsignacion(resultado) {
      const asignados = Number(resultado?.asignados);
      const solicitados = Number(resultado?.solicitados);

      if (!Number.isFinite(asignados)) {
        return "Leads asignados correctamente. Los datos fueron actualizados.";
      }

      let mensaje = Number.isFinite(solicitados)
        ? `Se asignaron ${asignados} de hasta ${solicitados} leads solicitados.`
        : `Se asignaron ${asignados} leads.`;
      const detalle = Array.isArray(resultado?.operadores)
        ? resultado.operadores
            .map((asignacion) => {
              const operador = this.agentesActivos.find(
                (agente) => String(agente.id) === String(asignacion.operadorId),
              );
              const nombre = operador
                ? this.nombreCompletoAgente(operador)
                : `Operador ${asignacion.operadorId}`;
              return `${nombre}: ${asignacion.asignados}`;
            })
            .join("; ")
        : "";

      if (detalle) {
        mensaje += ` ${detalle}.`;
      }

      return mensaje;
    },
    async LoadLeads(reiniciarPagina = false) {
      try {
        if (!this.$refs.filters) {
          return false;
        }

        let valid = this.$refs.filters.validate();
        if (!valid) {
          return false;
        }

        if (reiniciarPagina) {
          this.consultaRealizada = false;
          this.opcionesTabla.page = 1;
        }

        const filtros = this.crearFiltrosLeads(true);

        this.loading = true;
        let { data } = await this.$axios.post(
          `v1/bradescard/list/${localStorage.agenteUuid}`,
          filtros,
          {
            headers: {
              Authorization: "Bearer " + localStorage.agenteAccessToken,
            },
          },
        );

        const resultado = data.data || data;

        this.leads = Array.isArray(resultado.leads) ? resultado.leads : [];
        this.totalRegistros = Number(resultado.totalRegistros) || 0;
        this.consultaRealizada = true;
        this.loading = false;
        return true;
      } catch (exception) {
        this.loading = false;
        console.error(exception);
        return false;
      }
    },
    async asignacion() {
      if (this.asignando) {
        return false;
      }

      let asignacionCompletada = false;

      try {
        let valid = this.$refs.asignacion.validate();
        if (!valid) {
          return false;
        }

        this.asignando = true;

        const payload = {
          operadoresIds: this.form.operadoresIds,
          registros: this.form.registros,
          filtros: this.crearFiltrosLeads(),
        };
        const { data } = await this.$axios.post(
          "v1/bradescard/update/random/filtered",
          payload,
          {
            headers: {
              Authorization: "Bearer " + localStorage.agenteAccessToken,
            },
          },
        );
        const mensajeAsignacion = this.crearMensajeAsignacion(
          data.data || data,
        );
        asignacionCompletada = true;

        this.menu = false;
        this.form = {
          operadoresIds: [],
          registros: null,
        };

        this.consultaRealizada = false;
        this.opcionesTabla.page = 1;
        const [leadsActualizados] = await Promise.all([
          this.LoadLeads(),
          this.getProductosAseguradora(),
          this.getProductos(),
        ]);

        if (!leadsActualizados) {
          throw new Error("No fue posible actualizar la lista de leads");
        }

        this.notificacion = {
          visible: true,
          color: "success",
          mensaje: mensajeAsignacion,
        };

        this.$nextTick(() => {
          this.$refs.asignacion && this.$refs.asignacion.resetValidation();
        });
      } catch (exception) {
        console.error(exception);

        this.notificacion = {
          visible: true,
          color: asignacionCompletada ? "warning" : "error",
          mensaje: asignacionCompletada
            ? "Los leads fueron asignados, pero no se pudieron actualizar todos los datos."
            : exception.response?.data?.message ||
              "No fue posible asignar los leads. Intente nuevamente.",
        };
      } finally {
        this.asignando = false;
      }
    },
  },
};
</script>

<style>
.asignacion-card {
  width: 420px;
  max-width: calc(100vw - 32px);
}

.operadores-select .v-select__selections {
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  flex-wrap: wrap;
}

.operadores-select .operador-seleccion {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}
</style>
